import {Inject, Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {ExpensesCompressAttachmentsToZipRequest} from "../models/expenses-compress-attachments-to-zip-request.model";

@Injectable({providedIn: 'root'})
export class ExpensesHttpService {

  private base_url = `/expenses`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  compressToZip(params: ExpensesCompressAttachmentsToZipRequest) {
    const filteredParams = Object.keys(params).reduce((acc, key) => {
      const value = params[key];
      if (value !== null && value !== undefined && value !== '') {
        acc[key] = value;
      }
      return acc;
    }, {} as any);

    const httpParams = new HttpParams({
      fromObject: filteredParams
    });

    return this.http.get(`${this.base_url}/compress`, {
      responseType: 'blob',
      params: httpParams
    });
  }


}
